import { api } from '@/lib/api/api'

export type PlatformType = 'shopify' | 'wordpress' | 'framer'

export interface ConvertToRichTextRequest {
  markdown: string
  platform: PlatformType
}

export interface ConvertToRichTextResponse {
  success: boolean
  data: {
    html: string
    plainText: string
    platform: PlatformType
  }
  meta: {
    originalLength: number
    htmlLength: number
    plainTextLength: number
  }
}

export interface ConvertToRichTextErrorResponse {
  error: string
  details?: string | Array<{ field: string; message: string }>
}

/**
 * SEO Tools API for markdown conversion and other SEO utilities
 */
export const seoToolsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Convert markdown to rich text HTML optimized for specific platforms
     */
    convertToRichText: builder.mutation<ConvertToRichTextResponse, ConvertToRichTextRequest>({
      query: (body) => ({
        url: 'v2/seo-tools/convert-to-richtext',
        method: 'POST',
        body,
      }),
    }),

    /**
     * Get SEO tools health status
     */
    getSeoToolsHealth: builder.query<
      {
        success: boolean
        service: string
        timestamp: string
        endpoints: Array<{
          path: string
          method: string
          description: string
        }>
      },
      void
    >({
      query: () => ({
        url: 'v2/seo-tools/health',
        method: 'GET',
      }),
    }),
  }),
})

export const { useConvertToRichTextMutation, useGetSeoToolsHealthQuery } = seoToolsApi
